import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CoreModule } from "./core/core.module";
import { HttpClientModule } from "@angular/common/http";
import {
	FormsModule,
	EmailValidator,
	ReactiveFormsModule
} from "@angular/forms";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./pages/login/login.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { HeaderComponent } from "./layout/header/header.component";
import { LoaderComponent } from './layout/loader/loader.component';

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		ProfileComponent,
		HeaderComponent,
		LoaderComponent
	],
	imports: [
		BrowserModule,
		CoreModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule
	],
	providers: [],
	bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/app.module.ts